function addCommas(nStr) {
    nStr += '';
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? `.${x[1]}` : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

// DIFFERENT
function priceMultiplyGeneric() {
    const basePrice = $('#target-price-d').text();
    const quantity = $('#target-qty').val();
    const totalPrice = basePrice * quantity;
    const formatted = Number(totalPrice).toFixed(2);
    $('#multiply').text(addCommas(formatted));
}

function toNumber(value) {
    return parseFloat(value.replace(/,/g, '')) || 0;
}

function priceMultiplyLanterns() {
    const basePrice1 = toNumber($('#target-price1').text());
    const basePrice2 = toNumber($('#target-price2').text());
    const basePrice3 = toNumber($('#target-price3').text());
    const basePrice4 = toNumber($('#target-price4').text());
    const quantity1 = Number($('#target-qty1').val());
    const quantity2 = Number($('#target-qty2').val());
    const quantity3 = Number($('#target-qty3').val());
    const quantity4 = Number($('#target-qty4').val());
    const totalPrice =
        basePrice1 * quantity1 +
        basePrice2 * quantity2 +
        basePrice3 * quantity3 +
        basePrice4 * quantity4;
    $('#multiply').text(addCommas(totalPrice.toFixed(2)));
}

// Generic
$('#target-qty').on('change', function() {
    priceMultiplyGeneric();
});

// Lanterns
$('#target-qty1,#target-qty2,#target-qty3,#target-qty4').on('change', function() {
    priceMultiplyLanterns();
});

const selectors = {
    DETAIL: '.ajax-detail',
    LANTERNS_DETAIL: '.lanterns-detail',
    COLORWAY_CONTAINERS: '.colorway-container',
    COLORWAY_LINKS: '.colorway-link',
    PRODUCT_TITLE: '#target-title',
    
    PRODUCT_PRICE_DESKTOP: '#target-price-d', // Generic
    PRODUCT_SKU_MOBILE: '#target-sku-m', // Generic
    PRODUCT_SKU_DESKTOP: '#target-sku-d', // Generic
    PRODUCT_ID: '#target-id', // Generic
    
    PRODUCT_SKU: '.target-sku', // Lanterns
    PRODUCT_PRICE1: '#target-price1', // Lanterns
    PRODUCT_PRICE2: '#target-price2', // Lanterns
    PRODUCT_PRICE3: '#target-price3', // Lanterns
    PRODUCT_PRICE4: '#target-price4', // Lanterns
    PRODUCT_PRICE1b: '#target-price1b', // Lanterns
    PRODUCT_PRICE2b: '#target-price2b', // Lanterns
    PRODUCT_PRICE3b: '#target-price3b', // Lanterns
    PRODUCT_PRICE4b: '#target-price4b', // Lanterns
    PRODUCT_ID1: '#target-id1', // Lanterns
    PRODUCT_ID2: '#target-id2', // Lanterns
    PRODUCT_ID3: '#target-id3', // Lanterns
    PRODUCT_ID4: '#target-id4', // Lanterns

    // Images
    PRODUCT_SLIDES: '#target-slides',
    PRODUCT_MAIN_IMAGE: '#target-main-image',
    PRODUCT_MAIN_IMAGE_CAPTION: '#target-caption', // DIFFERENT
    PRODUCT_MAIN_IMAGE_CAPTION2: '#target-caption2', // DIFFERENT
    PRODUCT_SECONDARY_IMAGES: '#target-slides .slide.secondary-image',
    PRODUCT_CLONE_IMAGES: '#target-slides .slide.clone',
    IMAGE_SLIDER: '.flexslider',
    IMAGE_SLIDER_CONTROLS: '.flexslider .flex-control-nav',

    // Currency
    CART_CURRENCY_SELECT: 'select[name=paymentCurrency]',
    CART_CURRENCY_MOBILE: '#paymentCurrency1',
    CART_CURRENCY_DESKTOP: '#paymentCurrency2',

    // SAMPLE
    SAMPLE: '#target-sample',

    // Downloads
    TEAR_SHEET_1: '#target-tear1',
    TEAR_SHEET_2: '#target-tear2',
};

const initializeProductVariants = () => {
    const $detail = $(selectors.DETAIL);
    if ($detail.length === 0) {
        return;
    }

    const $lanternsDetail = $(selectors.LANTERNS_DETAIL);
    const isLanternPage = $lanternsDetail.length > 0;

    if (!isLanternPage) {
        priceMultiplyGeneric();
    } else {
        priceMultiplyLanterns();
    }

    // Handle the changing of colorways
    const $colorWayLinks = $(selectors.COLORWAY_LINKS);
    $colorWayLinks.on('click', e => {
        e.preventDefault();

        if (!isLanternPage) {
            priceMultiplyGeneric();
        } else {
            priceMultiplyLanterns();
        }

        const $target = $(e.target);
        const $colorwayLink = $target.is('a') ? $target : $target.closest('a');
        const $colorwayContainer = $colorwayLink.closest('li');

        // If user clicked on the colorway that is already active, ignore
        if ($colorwayContainer.hasClass('current')) {
            return;
        }

        // Update active state of colorway icons
        $(selectors.COLORWAY_CONTAINERS).removeClass('current');
        $colorwayContainer.addClass('current');

        // Replace data on page
        const {
            title,
            priceUsd, // Generic
            priceGbp, // Generic
            sku,
            id, // Generic
            priceusd1, // Lanterns
            priceusd2, // Lanterns
            priceusd3, // Lanterns
            priceusd4, // Lanterns
            pricegbp1, // Lanterns
            pricegbp2, // Lanterns
            pricegbp3, // Lanterns
            pricegbp4, // Lanterns
            id1, // Lanterns
            id2, // Lanterns
            id3, // Lanterns
            id4, // Lanterns
            image1_1x: mainImage1x,
            image1_2x: mainImage2x,
            image1_caption1,
            image1_caption2,
            ...colorwayData
        } = $colorwayLink.data();

        const currency = $(selectors.CART_CURRENCY_SELECT).val();
        const price = currency === 'USD' ? priceUsd : priceGbp; // Generic
        const price1 = currency === 'USD' ? priceusd1 : pricegbp1; // Lanterns
        const price2 = currency === 'USD' ? priceusd2 : pricegbp2; // Lanterns
        const price3 = currency === 'USD' ? priceusd3 : pricegbp3; // Lanterns
        const price4 = currency === 'USD' ? priceusd4 : pricegbp4; // Lanterns

        $(selectors.PRODUCT_TITLE).html(title);

        $(selectors.PRODUCT_PRICE_DESKTOP).html(price); // Generic
        $(selectors.PRODUCT_PRICE1).html(price1); // Lanterns
        $(selectors.PRODUCT_PRICE2).html(price2); // Lanterns
        $(selectors.PRODUCT_PRICE3).html(price3); // Lanterns
        $(selectors.PRODUCT_PRICE4).html(price4); // Lanterns
        $(selectors.PRODUCT_PRICE1b).html(price1); // Lanterns
        $(selectors.PRODUCT_PRICE2b).html(price2); // Lanterns
        $(selectors.PRODUCT_PRICE3b).html(price3); // Lanterns
        $(selectors.PRODUCT_PRICE4b).html(price4); // Lanterns

        $(selectors.PRODUCT_SKU_MOBILE).html(sku); // Generic
        $(selectors.PRODUCT_SKU_DESKTOP).html(sku); // Generic
        $(selectors.PRODUCT_SKU).html(sku); // Lanterns

        $(selectors.PRODUCT_ID).val(id); // Generic
        $(selectors.PRODUCT_ID1).val(id1); // Lanterns
        $(selectors.PRODUCT_ID2).val(id2); // Lanterns
        $(selectors.PRODUCT_ID3).val(id3); // Lanterns
        $(selectors.PRODUCT_ID4).val(id4); // Lanterns

        // Replace main image
        const $mainImage = $(selectors.PRODUCT_MAIN_IMAGE);
        $mainImage.attr('srcset', `${mainImage1x} 1x, ${mainImage2x} 2x`);
        $mainImage.attr('alt', title);
        $(selectors.PRODUCT_MAIN_IMAGE_CAPTION).html(image1_caption1); // Generic
        $(selectors.PRODUCT_MAIN_IMAGE_CAPTION2).html(image1_caption2); // Generic

        // Replace secondary images
        $(`${selectors.PRODUCT_SECONDARY_IMAGES}, ${selectors.PRODUCT_CLONE_IMAGES}`).remove();
        const $slides = $(selectors.PRODUCT_SLIDES);

        let imageIndex = 2;
        let imageSrc1x = colorwayData[`image${imageIndex}_1x`];
        let imageSrc2x = colorwayData[`image${imageIndex}_2x`];
        let imageAlt = colorwayData[`image${imageIndex}_alt`];
        let imageCaption1 = colorwayData[`image${imageIndex}_caption1`];
        let imageCaption2 = colorwayData[`image${imageIndex}_caption2`];

        while (imageSrc1x) {
            $slides.append(`
                <div class="slide secondary-image">
                    <figure>
                        <img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
                            srcset="${imageSrc1x} 1x, ${imageSrc2x} 2x"
                            alt="${imageAlt}"
                        >

                        ${
                            imageCaption1
                                ? `
                                    <figcaption>
                                        ${imageCaption1}
                                        ${
                                            imageCaption2
                                                ? `
                                                    <span><br>
                                                        ${imageCaption2}
                                                    </span>
                                                    `
                                                : ''
                                        }
                                    </figcaption>
                                    `
                                : ''
                        }
                    </figure>
                </div>
            `);

            imageIndex += 1;
            imageSrc1x = colorwayData[`image${imageIndex}_1x`];
            imageSrc2x = colorwayData[`image${imageIndex}_2x`];
            imageAlt = colorwayData[`image${imageIndex}_alt`];
            imageCaption1 = colorwayData[`image${imageIndex}_caption1`];
            imageCaption2 = colorwayData[`image${imageIndex}_caption2`];
        }

        // Reset flexslider
        const $slider = $(selectors.IMAGE_SLIDER);
        $(selectors.IMAGE_SLIDER_CONTROLS).remove();
        $slider.removeData('flexslider');
        $slider.flexslider({
            selector: '.slides > .slide',
            animation: 'slide',
            smoothHeight: false,
            slideshow: false,
        });

        // Update url
        const urlSegments = window.location.pathname.split('/').filter(segment => segment.length > 0);
        const productType = urlSegments[0];
        const productSlug = urlSegments[2];
        window.history.pushState(null, '', `/${productType}/catalog/${productSlug}/${sku}`);

        // Update sample urls
        const newSampleUrl = !isLanternPage
            ? `/${productType}/catalog/${productSlug}/${sku}/sample`
            : `/materials/finishes/${sku}/sample`;

        $(selectors.SAMPLE).attr('href', newSampleUrl);

        // Update tear sheet download urls
        const newDownloadUrl = `/${productType}/tear-sheets/${productSlug}/${sku}`;
        $(selectors.TEAR_SHEET_1).attr('href', newDownloadUrl);
        $(selectors.TEAR_SHEET_2).attr('href', newDownloadUrl);
    });
};

export default initializeProductVariants;
